// import '../app/index';
const myCustomContext = require.context('app', true);
const ReactRailsUJS = require('react_ujs');
// use `custom_components/` for <%= react_component(...) %> calls
ReactRailsUJS.useContext(myCustomContext);
